import { render, staticRenderFns } from "./authLogin.vue?vue&type=template&id=70fc16ec&scoped=true&"
import script from "./authLogin.vue?vue&type=script&lang=js&"
export * from "./authLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fc16ec",
  null
  
)

export default component.exports